// extracted by mini-css-extract-plugin
module.exports = {"last":"Navbar_last__17a2J","dropdownToggle":"Navbar_dropdownToggle__38ZxM","syncDropdownMenu":"Navbar_syncDropdownMenu__1J0Ul","sticky":"Navbar_sticky__3zNh_"};